export default __webpack_public_path__ + "static/media/ic_india.7420f1fc.svg";